export const createMarkup = (string: any) => {
  return {
    __html: string,
  };
};
